import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import VeteransHealthWellnessDetails from '../../subdepartmentdetails/VeteransHealthWellness'


function VeteransHealthWellness() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Veterans' Health and Wellness Services || Veterans Affairs";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Veterans Affairs"
            title="Veterans Health Wellness"
            subtitledown="Department of Veterans Affairs"
           />
            <VeteransHealthWellnessDetails/>
        </div>
    </>
  )
}

export default VeteransHealthWellness